/* eslint-disable no-class-assign */
/* eslint-disable no-return-assign */
/* eslint-disable testing-library/no-debug */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/sort-comp */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable class-methods-use-this */
import Debug from 'debug';
import Editor from 'draft-js-plugins-editor';
import 'draft-js/dist/Draft.css';
import {fromJS} from 'immutable';
import {Component} from 'react';
import {connect} from 'react-redux';
import Textarea from 'react-textarea-autosize';
import {
  getEditorState,
  setCompositionEditorState,
} from 'store/reducers/compositions';
import isEmpty from 'utils/functions/isEmpty';
import './BasicEditor.scss';
import {
  filterAllowedUnicodeCharsFromText,
  getSanitizedEditorState,
} from './lib/editorUtils';
import getFullTextFromEditorState from './lib/get-full-text-from-editor-state';
import LetrusTheme, {blockRenderMap} from './plugins/LetrusTheme';

const debug = Debug('letrus:BasicEditor'); // eslint-disable-line new-cap

const letrusTheme = LetrusTheme();
const plugins = [letrusTheme];

class BasicEditor extends Component {
  getLastChars(editorState) {
    const blockMap = editorState.getCurrentContent().getBlockMap();
    const currentSelection = editorState.getSelection();
    const block = blockMap.get(currentSelection.anchorKey);
    return block.getText()[currentSelection.anchorOffset - 1];
  }

  /**
   * Push an event onto the capturer. If the push fails (queue is too large,
   * last response was too long ago), restarts the session.
   */

  /**
   * Converts current/previous selection states using
   * `BasicEditor::serializeSelectionState`.
   */

  serializeSelectionStates(newEditorState, options = {}) {
    const {editorState: previousEditorState} = this.props;
    return this.compactObject({
      previousSelection:
        !options.omitPrevious && previousEditorState
          ? this.serializeSelectionState(
              previousEditorState,
              previousEditorState.getSelection(),
            )
          : null,
      currentSelection: this.serializeSelectionState(
        newEditorState,
        newEditorState.getSelection(),
      ),
    });
  }

  /**
   * Convert a selection state to the key-logger format.
   *
   * This is essentially converting from Draft.js' block *keys* to paragraph
   * *indexes*.
   */

  serializeSelectionState(editorState, selectionState) {
    selectionState = selectionState.toJSON();
    const blockMap = editorState.getCurrentContent().blockMap.toArray();
    const anchorIndex = blockMap.findIndex((contentBlock) => {
      return contentBlock.key === selectionState.anchorKey;
    });
    const focusIndex = blockMap.findIndex((contentBlock) => {
      return contentBlock.key === selectionState.focusKey;
    });

    return {
      anchorOffset: selectionState.anchorOffset,
      focusOffset: selectionState.focusOffset,
      hasFocus: selectionState.hasFocus,
      isBackward: selectionState.isBackward,
      anchorIndex,
      focusIndex,
    };
  }

  /**
   * Removes null/undefined values from an object
   */

  compactObject(object, {removeFalsy = false, removeEmpty = false} = {}) {
    return Object.keys(object).reduce((memo, key) => {
      let shouldKeep = removeFalsy ? object[key] : object[key] != null;

      if (removeEmpty && isEmpty(object[key])) {
        shouldKeep = false;
      }

      if (shouldKeep) {
        memo[key] = object[key];
      }
      return memo;
    }, {});
  }

  onEditorChange = (editorState) => {
    if (this.props.disabled) {
      return;
    }

    debug('BasicEditor::onEditorChange');

    // `this.props.editorState` may change when we call
    // `this.props.setCompositionEditorState`
    const oldEditorState = this.props.editorState;

    const editorText = getFullTextFromEditorState(editorState).join('\n\n');

    const cleanedEditorText = getSanitizedEditorState(editorText, editorState);

    this.props.setCompositionEditorState(cleanedEditorText);

    if (this.props.onChange) {
      this.props.onChange(editorState, oldEditorState);
    }
  };

  onSubmitTitle = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.onChangeTitle(e, false);
    this.onChangeText(e, false);
  };

  onKeyDownTitle = (e) => {
    if (e.keyCode === 9) {
      return;
    }

    if (
      this.props.compositionTitle &&
      this.props.compositionTitle.split(' ').filter((s) => !!s).length >= 13 &&
      // Enter
      e.keyCode !== 13 &&
      // Backspace
      e.keyCode !== 8 &&
      // Left arrow
      e.keyCode !== 37 &&
      // Up arrow
      e.keyCode !== 38 &&
      // Down arrow
      e.keyCode !== 40 &&
      // Right arrow
      e.keyCode !== 39
    ) {
      e.preventDefault();
      return;
    }

    if (e.keyCode === 13) {
      e.preventDefault();
      this?.editor?.focus();
    }
  };

  onChangeTitle = (e, noTitle = false) => {
    if (this.props.disabled) {
      return;
    }

    debug('BasicEditor::onChangeTitle');
    const {compositionId, compositionTitle} = this.props;
    const valueWithoutLineBreaks = e?.target?.value?.replaceAll?.('\n', ' ');
    const title = e && e.target ? valueWithoutLineBreaks : compositionTitle;

    this.props.setCompositionLocalState(
      fromJS({
        ...this.props.composition.toJS(),
        id: compositionId,
        title,
        clientModified: new Date(),
        noTitle,
      }),
    );

    this.props.onChangeTitle(title);
    this.props.monitorTitleLimit(e.target.value);
  };

  onChangeText = (event) => {
    if (this.props.disabled) {
      return;
    }

    debug('BasicEditor::onChangeText');
    const {
      compositionId, // compositionTextHtml,
      onChangeText,
    } = this.props;

    const cleanedText = filterAllowedUnicodeCharsFromText(event.target.value);

    this.props.setCompositionLocalState(
      fromJS({
        ...this.props.composition.toJS(),
        id: compositionId,
        fromMobile: true,
        composition_raw: cleanedText,
        clientModified: new Date(),
      }),
    );

    onChangeText(event);
  };

  onEditorWrapperRef = (editorWrapper) => {
    this.editorWrapper = editorWrapper;
  };

  onEditorRef = (editor) => {
    this.editor = editor;
  };

  stripHTML = (text) =>
    text
      .replace(/\n+/g, '')
      .replace(/<\/p[^>]*>\s*<p[^>]*>/g, '\n')
      .replace(/<\/?p[^>]*>/g, '');

  renderMobileEditor() {
    const {disabled, onPaste} = this.props;
    const simpleText = this.props.compositionRaw;

    return (
      <Textarea
        className="CompositionText"
        name="composition"
        value={simpleText}
        onChange={this.onChangeText}
        onPaste={(event) => onPaste?.(event.clipboardData.getData('text'))}
        placeholder="Digite (ou cole) sua redação aqui"
        autoComplete="off"
        spellCheck="false"
        disabled={disabled}
        cacheMeasurements
      />
    );
  }

  render() {
    const {disabled, onPaste} = this.props;

    return (
      <div className="Editor">
        <form
          onSubmit={this.onSubmitTitle}
          autoComplete="off"
          className="Composition"
        >
          {!this.props.isHidingTitle && (
            <Textarea
              title="título"
              className="CompositionTitle"
              disabled={disabled}
              name="title"
              aria-label="Título da Redação"
              ref={(input) => (this.title = input)}
              value={this.props.compositionTitle}
              placeholder="Adicione um título"
              onChange={this.onChangeTitle}
              onKeyDown={this.onKeyDownTitle}
              autoComplete="off"
              spellCheck="false"
              role="textbox"
              tabIndex={0}
              maxLength={200}
            />
          )}
          <div
            id="text_editor"
            className="CompositionEditor"
            ref={this.onEditorWrapperRef}
          >
            {this.props.isMobile
              ? this.renderMobileEditor()
              : this.props.editorState && (
                  <Editor
                    ref={this.onEditorRef}
                    readOnly={disabled}
                    stripPastedStyles
                    editorState={this.props.editorState}
                    onChange={this.onEditorChange}
                    placeholder="Digite (ou cole) sua redação aqui"
                    role="textbox"
                    ariaDescribedBy="text_editor"
                    ariaMultiline="true"
                    tabIndex={0}
                    plugins={plugins}
                    blockRenderMap={blockRenderMap}
                    handleKeyCommand={(key) => {
                      this._lastKey = key;
                    }}
                    handlePastedText={(text) => {
                      this._pastedText = text;
                      onPaste?.(text);
                    }}
                  />
                )}
          </div>
        </form>
      </div>
    );
  }
}

BasicEditor = connect(
  (state, props) => {
    const eEditorState = getEditorState(state);

    return {
      editorState:
        !props.compositionIsLoading && eEditorState ? eEditorState : null,
    };
  },
  {
    setCompositionEditorState,
  },
)(BasicEditor);

export default BasicEditor;
